import { getIsCheckedProducts } from 'common/helpers/get-is-checked-products.helper';
import { TData } from 'entries/common/widgets/context';
import { TState } from 'pages/dimensions/store/dimensions';
import { TComplimentaryProductsState } from '../types/complimentary-products-state.type';

type TAllProductsInBasket = {
  productId: string;
  price: number | undefined;
  name: string | undefined;
  productQuantity: number;
};

export const getAllProductsInBasket = ({
  dimensions,
  data,
  count,
  complimentaryProducts,
}: {
  dimensions: TState;
  data: TData | null;
  count: number;
  complimentaryProducts: TComplimentaryProductsState;
}) => {
  const mainProduct = dimensions.items.map(item => ({
    productId: item.productId,
    price: data?.mainPrice,
    name: data?.displayedName,
    productQuantity: count,
  }));

  const allComplementaryProducts = Object.values(complimentaryProducts)
    .map(item => {
      const isCheckedProduct = getIsCheckedProducts({
        checkedProducts: dimensions.checkedProducts,
        productId: item.productId,
      });
      return isCheckedProduct
        ? {
            productId: item.productId,
            price: item.salesPriceValueInConsumerUnitValue,
            name: item.displayedName.value?.[0],
            productQuantity: item.total.requiredQuantity,
          }
        : null;
    })
    .filter(item => item !== null) as TAllProductsInBasket[];
  return mainProduct.concat(allComplementaryProducts);
};
